import dateTimeStrings from 'owa-strings/owa-datetime-strings';
import { errorThatWillCauseAlert } from 'owa-trace';
import { initializeTranslationsWithFunc as initializeOwaDateTimeTranslationsWithFunc } from 'owa-datetime-formatters-core/lib/localization/getLocalizedString';
import { initializeTranslationsWithFunc as initializeOwaTimeFormatTranslationsWithFunc } from 'owa-timeformat/lib/localization/getLocalizedString';

export const initializeTranslationsForOwaDateTime = () => {
    initializeOwaDateTimeTranslationsWithFunc(owaTimeformatLocalizer);
    initializeOwaTimeFormatTranslationsWithFunc(owaTimeformatLocalizer);
};

/**
 * We are using the owa-strings package modules to replicate the same behavior as owa-locstrings package in client-web with same resourceIds.
 * The resourceIds for localizing date-time strings are present in 'owa-datetime-strings' modules in owa-strings package.
 * Refer packages/framework/datetime/owa-timeformat-localization/src/index.ts in client-web.
 */
function owaTimeformatLocalizer(resourceId: string): string {
    const formattedDateTime = dateTimeStrings[resourceId];

    if (typeof formattedDateTime !== 'string') {
        // The missing resourceIds should be added in 'owa-datetime-strings' module, the value should be same as owa-locstrings package in client-web.
        errorThatWillCauseAlert(`[dateTimeLocError] Missing resourceId: ${resourceId}`);
        return '';
    }

    return formattedDateTime;
}
